export class RequestsFilterInfo {
    searchTerm: string | null;
    categoryIds: number[] | null;
    itemTypeIds: number[] | null;
    statusTypeIds: number[] | null;
    awaitingMyApproval: boolean;
    awaitingMyInputs: boolean;
    createdFromDate: string;
    createdToDate: string;
    openRequestsOnly: boolean;

}
